/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
function initAboutIntro(sectionId) {
  var $section = $('#about-intro-' + sectionId);
  if (!$section.length) return;

  var $srElements = $section.find('.sr-hidden');
  if (!$srElements.length) return;

  function showInstantly($elements) {
    $elements.each(function () {
      if (typeof ScrollReveal !== 'undefined') ScrollReveal().clean(this);
      $(this).css({ visibility: 'visible', opacity: 1, transform: 'none' });
    });
  }

  if (window.innerWidth > 799 && typeof ScrollReveal !== 'undefined') {
    $srElements.each(function (i, el) {
      ScrollReveal().reveal(el, {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 40 + (i * 40),
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });
    });
  } else {
    showInstantly($srElements);
  }
}

$(function () {
  var instances = window.DeskAboutIntro || {};
  $.each(instances, function (id) {
    initAboutIntro(id);
  });
});
